"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.pass_reset.subject': 'Solicitud de Restablecimiento de Contraseña',
    'email.pass_reset.title': 'Restablecer Su Contraseña',
    'email.pass_reset.text': 'Ha solicitado restablecer su contraseña. Haga clic en el botón de abajo para establecer una nueva contraseña.',
    'email.pass_reset.button': 'Restablecer Contraseña',
};
